import * as React from "react";

const ListIcon = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M26.45 10.1L17.45 1.59998C16.95 1.09998 16.3 0.849976 15.6 0.849976H7.4C5.9 0.849976 4.7 2.04998 4.7 3.54998V28.4C4.7 29.9 5.9 31.1 7.4 31.1H24.6C26.1 31.1 27.3 29.9 27.3 28.4V12.05C27.3 11.3 27 10.6 26.45 10.1ZM17.15 4.39998L23.45 10.3H17.6C17.35 10.3 17.15 10.1 17.15 9.89997V4.39998ZM24.6 28.9H7.4C7.15 28.9 6.95 28.7 6.95 28.45V3.59998C6.95 3.34998 7.15 3.14998 7.4 3.14998H14.85V9.89997C14.85 11.35 16.05 12.55 17.55 12.55H25.05V28.4C25.05 28.65 24.85 28.9 24.6 28.9Z"
      fill="currentColor"
    />
    <rect x="13" y="17" width="9" height="2" rx="1" fill="currentColor" />
    <rect x="13" y="23" width="9" height="2" rx="1" fill="currentColor" />
    <circle cx="11" cy="24" r="1" fill="currentColor" />
    <circle cx="11" cy="18" r="1" fill="currentColor" />
  </svg>
);

export default ListIcon;